import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import React from 'react';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';
import { httpService } from '../../../services/http.service';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { IServerErrorResponse } from '../../../types';
import LiliNotification, { LiliNotificationType } from '../../../DesignSystem/LiliNotification/LiliNotification';
import { LiliToastDefaultConfig } from '../../../DesignSystem/LiliToast/LiliToast';
import { endpointManager } from '../../../services/endpoint.service';

interface IProps {
  supplierId: string;
  amount: number;
  memo: string;
  billId?: string;
}

export const postMailCheckReview = () => {
  const { postMailCheckReviewUrl } = endpointManager();

  return useMutation(
    'usePostCheck',
    async (props: IProps) => {
      const { supplierId, amount, memo } = props;

      const res = await httpService.post(postMailCheckReviewUrl(), {
        supplierId,
        amount,
        memo: memo || null,
      });
      return res.data;
    },
    {
      retry: 1,
      onError: (e: IServerErrorResponse) => {
        const { localizedMessage, code } = flattenServerErrorResponse(e);
        toast(<LiliNotification undismissable type={LiliNotificationType.ERROR} text={localizedMessage} id='vendorDetailsError' />, { ...LiliToastDefaultConfig });
        trackMixPanel('Error Occurred During Move Money Flow', {
          'Error Code': code, 'Error Message': localizedMessage, 'Screen Name': 'Review', Flow: 'Mail a Check',
        });
      },
    },
  );
};
